import React from 'react';
import './LoadingScreen.css';

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <div className="loading-content">
        <svg className="loading-logo" viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg">
          <path fill="rgb(110, 200, 183)" d="M210.378,9.148 L440.233,141.918 L315.404,213.515 L86.932,80.194 L210.378,9.148 Z"/>
          <path fill="rgb(111, 190, 68)" d="M440.233,141.918 L439.559,284.709 L315.404,213.515 L440.233,141.918 Z"/>
          <path fill="rgb(178, 210, 52)" d="M190.337,284.635 L315.404,213.515 L439.559,284.709 C439.823,284.524 86.126,488.566 86.322,488.566 C86.518,488.566 190.104,285.053 190.337,284.635 Z"/>
          <path fill="rgb(237, 29, 54)" d="M86.322,488.566 L86.744,224.115 L189.544,164.642 L190.104,285.053 L86.322,488.566 Z"/>
        </svg>
      </div>
    </div>
  );
};

export default LoadingScreen;
